// ─────────────────────────────────────────────────────────────────────
// Defensive coercions for hand-authored / still-moving feed data.
// ─────────────────────────────────────────────────────────────────────
//
// The ARAM Mayhem and League Classic feeds are produced by pipelines
// that are still churning, so a field can arrive with an unexpected
// shape (or get renamed) without TypeScript noticing — the payload types
// are assertions about a remote file, not guarantees. These keep a bad
// shape rendering empty instead of throwing (`.split` on a non-string,
// `.map`/`.forEach` on a non-array). Missing data on the page always
// beats a crashed page, especially since these run during render.
//
// Apply at the point where fetched data is first split or iterated —
// not everywhere. If a value came from our own code rather than a feed,
// coercing it just hides a real bug.

export const asText = (value: unknown): string => (typeof value === "string" ? value : "");

export function asArray<T>(value: readonly T[] | null | undefined): T[] {
  return Array.isArray(value) ? (value as T[]) : [];
}
